import { motion } from "framer-motion";
import { Scissors, Sparkles, Heart, Hand } from "lucide-react";

const features = [
  {
    icon: Hand,
    title: "Feito à mão",
    description: "Cada peça é produzida manualmente com técnicas tradicionais de crochê.",
  },
  {
    icon: Sparkles,
    title: "Exclusividade",
    description: "Produção limitada garante que você terá uma peça única e especial.",
  },
  {
    icon: Scissors,
    title: "Conforto e estilo",
    description: "Beleza que não abre mão do conforto, perfeita para o dia a dia.",
  },
  {
    icon: Heart,
    title: "Carinho no processo",
    description: "Atenção aos detalhes em cada ponto, do início ao acabamento.",
  },
];

const Features = () => {
  return (
    <section className="section-padding bg-secondary/30">
      <div className="container-narrow">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-4">
            Por que escolher a Solar Crocheteria
          </h2>
          <div className="decoration-line max-w-xs mx-auto" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="card-artesanal p-6 md:p-8 text-center"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10 text-primary mb-5">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
